<template>
  <div>
    <slot v-if="cookieRef === true" />
    <div v-else-if="cookieRef === false">
      <ContentPlaceholder
        :title="`Je hebt onze ${cookieType} cookies (nog) niet geaccepteerd.`"
        :text="`Doet dit onderdeel van deze website het niet? Voor een volledig werkende website accepteer je hier de ${cookieType} cookies.`"
        :cookie="true"
        icon="cookie"
        variant="narrow"
      />
    </div>
    <!-- cookieRef === null: nog niet bekend (SSR / voor hydratie), niets tonen -->
  </div>
</template>

<script setup lang="ts">
import type { TCookie } from '~~/types/local_types';

const emit = defineEmits(['allowed']);
const { cookieDebug } = useRuntimeConfig().public;

// Altijd neutraal tijdens SSR -> identieke HTML voor iedereen -> cache-safe
const cookieRef = ref<boolean | null>(null);

interface IProps {
  cookieType?: TCookie;
}

const props = withDefaults(defineProps<IProps>(), {
  cookieType: 'social',
});

const cookieMappings = {
  social: 'Cookie_Category_Social',
  overige: 'Cookie_Category_Miscellaneous',
  noCookie: 'Cookie_Category_No_Cookie',
};

const { sld, top } = useUrl();

const cookie = useCookie(cookieMappings[props.cookieType], {
  domain: `.${sld}.${top}`,
  default: () => false,
});

const checkCookie = () => {
  if (import.meta.client) {
    if (cookieDebug || props.cookieType === 'noCookie') {
      cookieRef.value = true;
    } else {
      cookieRef.value = cookie.value || false;
    }
    emit('allowed', cookieRef.value);
  }
};

onMounted(() => {
  checkCookie();
});

// Reageer op latere wijzigingen, bv. via het cookie-instellingen paneel
watch(cookie, () => {
  if (import.meta.client) checkCookie();
});
</script>
